<div class="question-group">

  <div class="top-question">
    <input
      class="top-checkbox"
      type="checkbox"
      (click)="$event.stopPropagation()"
      (change)="toggleTop()"
      [checked]="topChecked"
    />
    <span>{{ title }}</span>
  </div>

  <div class="sub-questions" *ngIf="topChecked">
    <div class="sub-item" *ngFor="let sub of subQuestions">
      <input class="sub-checkbox"
        type="checkbox"
        (change)="toggleSub(sub)"
        [checked]="subChecked[sub]"
      />
      <span>{{ sub }}</span>
    </div>
  </div>

</div>
